import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { sendSMS, checkSMS } from 'redux/brand/actionCreators';
import { scrollIntoView } from 'scroll-js';

import styles from './styles';

const {
    SmsBlockButton,
    SmsBlockContainer,
    SmsBlockError,
    SmsBlockInput,
    SmsBlockInputContainer,
    SmsBlockTitle,
    TimerComponent,
    TimerLoader,
} = styles;

const TIMER_DURATION = 45;

class SmsBlock extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            seconds: 0,
            isTouched: false, // initial state, should always be `true`` after first click on the `send` button
            isInputRendered: false,
            isPending: false,
            isCodeConfirmed: false,
            value: '',
            error: '',
            buttonName: 'Получить код',
        };
        this.input = React.createRef();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.smsCheckStatus.isLoaded
          && this.props.smsCheckStatus.data.status !== prevProps.smsCheckStatus.data.status
        ) {
            if (this.props.smsCheckStatus.data.status === 'correct') {
                this.stopTimer();
                this.setState({
                    isCodeConfirmed: true,
                });
                this.props.handleClose();
            } else {
                this.stopTimer(this.props.smsCheckStatus.error || 'Неверный код');
                this.setState({
                    buttonName: 'Получить повторно',
                });
            }
        }
    }

    sendCode = () => {
        if (!this.state.isPending) {
            const url = document.location.href;
            const parsedUrl = new URL(url);
            const token = parsedUrl.pathname.replace(`${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '');
            if (token !== 'callback' && token !== '/callback') {
                this.props.sendSMS(token.split('/')[1]);
                this.startTimer();
            }
        }
    };

    startTimer = () => {
        if (!this.state.isPending) {
            this.setState({
                value: '',
                error: '',
                seconds: TIMER_DURATION,
                isPending: true,
                isTouched: true,
                isInputRendered: true,
            }, () => {
                this.interval = setInterval(this.tick, 1000);
                this.input.current.focus();
            });
        }
    };

    stopTimer = (error = '') => {
        this.setState({
            isPending: false,
            isInputRendered: false,
            error,
            value: '',
        });
        clearInterval(this.interval);
    };

    tick = () => {
        this.setState({
            seconds: this.state.seconds - 1,
        }, () => {
            if (this.state.seconds === 0) {
                this.setState({
                    isInputRendered: false,
                });
                this.stopTimer('Истекло время действия кода');
                this.setState({
                    buttonName: 'Получить код',
                });
            }
        });
    };

    handleChange = (e) => {
        this.setState({
            value: e.target.value,
        }, () => {
            if (this.state.value.length === 4) {
                const url = document.location.href;
                const parsedUrl = new URL(url);
                const token = parsedUrl.pathname.replace(`${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '');
                if (token !== 'callback' && token !== '/callback') {
                    this.props.checkSMS(token.split('/')[1], this.state.value);
                }
            }
        });
    };

    handleFocus = (e) => {
        e.preventDefault();
        const node = e.currentTarget;
        scrollIntoView(node, document.getElementById('checkStatusModal'), { behavior: 'smooth' })
            .then(() => null);
    };


    render() {
        const {
            isPending,
            isInputRendered,
            isCodeConfirmed,
            seconds,
            error,
            value,
            buttonName,
        } = this.state;

        return (
            <SmsBlockContainer>
                <SmsBlockTitle error={error}>
                  Код из СМС {error ? <SmsBlockError>- {error}</SmsBlockError> : null}
                </SmsBlockTitle>
                <SmsBlockInputContainer>
                    <SmsBlockButton onClick={this.sendCode} isPending={isPending} disabled={isCodeConfirmed}>
                        {isPending ? (
                            <TimerComponent>
                                <TimerLoader />
                                {seconds} c
                            </TimerComponent>
                        ) : buttonName}
                    </SmsBlockButton>
                    {isCodeConfirmed ? (
                        <span>confirmed</span>
                    ) : (
                        isInputRendered && (
                            <SmsBlockInput
                                ref={this.input}
                                type="text"
                                autoComplete="off"
                                inputMode="numeric"
                                maxLength="4"
                                value={value}
                                onChange={this.handleChange}
                                onFocus={this.handleFocus}
                            />
                        )
                    )}
                </SmsBlockInputContainer>
            </SmsBlockContainer>
        );
    }
}

export default connect(
    state => ({
        smsSendStatus: state.brand.smsSendStatus,
        smsCheckStatus: state.brand.smsCheckStatus,
    }),
    {
        sendSMS,
        checkSMS,
    },
)(SmsBlock);
